import { useState, useEffect } from "react";
import { Tag, X } from "lucide-react";

const KEY = "gtg_banner_dismissed";

// Thin, dismissible site-wide bar advertising the auto-applied GHOST20 code.
// Publishes its height as the --banner-h CSS var so the fixed navbar can offset.
export const DiscountBanner = ({ onCta }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY) === "1") return;
    setShow(true);
    document.documentElement.style.setProperty("--banner-h", "36px");
    return () => document.documentElement.style.setProperty("--banner-h", "0px");
  }, []);

  const dismiss = (e) => {
    e.stopPropagation();
    localStorage.setItem(KEY, "1");
    setShow(false);
    document.documentElement.style.setProperty("--banner-h", "0px");
  };

  if (!show) return null;

  return (
    <div
      data-testid="discount-banner"
      onClick={onCta}
      className="fixed top-0 inset-x-0 z-[60] h-9 bg-accent text-white flex items-center justify-center gap-2 px-10 cursor-pointer select-none"
    >
      <Tag size={13} className="flex-shrink-0" />
      <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-center leading-none">
        <span className="font-bold">GHOST20</span> — 20% off, auto-applied at checkout
      </span>
      <button
        type="button"
        data-testid="discount-banner-close"
        onClick={dismiss}
        aria-label="Dismiss offer"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors"
      >
        <X size={15} />
      </button>
    </div>
  );
};
